if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
        
        // Bind methods to preserve context for proper event listener removal
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleOverlayTouchStart = this.handleOverlayTouchStart.bind(this);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        
        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        this.hero_overlay = video_background_section.querySelector(".hero__overlay");
        // Find the visible video (not hidden by mobile-hidden or desktop-hidden classes)
        const allVideos = video_background_section.querySelectorAll("video");
        this.background_video_element = Array.from(allVideos).find(video => {
          const computedStyle = window.getComputedStyle(video);
          return computedStyle.display !== 'none';
        }) || allVideos[0]; // Fallback to first video if none found visible
        
        if (this.background_video_element && this.hero_overlay) {
          this.hero_overlay.addEventListener("touchstart", this.handleOverlayTouchStart, { passive: true });
          this.hero_overlay.addEventListener("click", this.handleOverlayClick);
        }
      }

      checkAndPlayVideoSection(video) {
        this.section_video_element = video.querySelector("video");
        
        if (this.section_video_element) {
          video.addEventListener("touchstart", this.handleTouchStart, { passive: true });
          video.addEventListener("click", this.handleClick);
        }
      }

      handleTouchStart() {
        if (this.section_video_element) {
          this.playVideo(this.section_video_element);
        }
      }

      handleClick() {
        if (this.section_video_element) {
          this.playVideo(this.section_video_element);
        }
      }

      handleOverlayTouchStart() {
        if (this.background_video_element) {
          this.playVideo(this.background_video_element);
        }
      }

      handleOverlayClick() {
        if (this.background_video_element) {
          this.playVideo(this.background_video_element);
        }
      }

      playVideo(video_element) {
        if (video_element.paused) {
          video_element.play();
        }
      }

      disconnectedCallback() {
        if (this.video_section && this.section_video_element) {
          this.video_section.removeEventListener("touchstart", this.handleTouchStart);
          this.video_section.removeEventListener("click", this.handleClick);
        }
        
        if (this.hero_overlay && this.background_video_element) {
          this.hero_overlay.removeEventListener("touchstart", this.handleOverlayTouchStart);
          this.hero_overlay.removeEventListener("click", this.handleOverlayClick);
        }
      }
    },
  );
}
